export const drums = [
  {
    key: 'q',
    name: 'Heater 1',
    id: 'heater-1',
    char: 'Q',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3',
  },
  {
    key: 'w',
    name: 'Heater 2',
    id: 'heater-2',
    char: 'W',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3',
  },
  {
    key: 'e',
    name: 'Heater 3',
    id: 'heater-3',
    char: 'E',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3',
  },
  {
    key: 'a',
    name: 'Heater 4',
    id: 'heater-4',
    char: 'A',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3',
  },
  {
    key: 's',
    name: 'Clap',
    id: 'clap',
    char: 'S',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3',
  },
  {
    key: 'd',
    name: 'Open HH',
    id: 'open-hh',
    char: 'D',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3',
  },
  {
    key: 'z',
    name: 'Kick n\' Hat',
    id: 'kick-n-hat',
    char: 'Z',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3',
  },
  {
    key: 'x',
    name: 'Kick',
    id: 'kick',
    char: 'X',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3',
  },
  {
    key: 'c',
    name: 'Closed HH',
    id: 'closed-hh',
    char: 'C',
    url: 'https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3',
  },
];